import React from 'react';

import { Divider, Popover, Typography } from 'antd';

import { Box } from '~/components';

import { Constants } from '@portal/config/env';
import { ProfileType } from '@portal/enum';
import { useReduxState } from '~/hooks';
import { getCookie, translate } from '~/services';
import { RenderCondition } from '~/utils';

import './PopoverSchoolManagement.less';

interface PropsPopoverSchoolManagement {
  children: React.ReactElement;
}

const PopoverSchoolManagement = ({ children }: PropsPopoverSchoolManagement) => {
  const {
    auth: { me },
    brand: { brandConfig },
  } = useReduxState();

  const token = getCookie('portal-token') || getCookie('lms-auth-token');

  const options = [
    {
      title: translate('COMPONENTS.POPOVER_SCHOOL_MANAGEMENT.USERS'),
      link: `${Constants.dashboardUrl}/redirect?token=${token}&currentPath=users`,
    },
    {
      title: translate('COMPONENTS.POPOVER_SCHOOL_MANAGEMENT.CLASSES'),
      link: `${Constants.dashboardUrl}/redirect?token=${token}&currentPath=classes`,
    },
    {
      title: translate('COMPONENTS.POPOVER_SCHOOL_MANAGEMENT.ADVISER_AREA'),
      action: () => `${Constants.dashboardUrl}/redirect?token=${token}&currentPath=adviser-area`,
      permissions: [ProfileType.ADVISER],
    },
  ];

  return (
    <Popover
      placement="bottom"
      content={
        <Box className="popover-management">
          {options
            ?.filter(
              (option) => option.permissions?.includes(me?.profileType as ProfileType) || !option.permissions?.length
            )
            ?.map((option, key) => (
              <a key={key} href={option.link}>
                <RenderCondition condition={key !== 0}>
                  <Divider />
                </RenderCondition>
                <Typography className="popover-management__text" style={{ color: brandConfig?.primaryColor }}>
                  {option.title}
                </Typography>
              </a>
            ))}
        </Box>
      }
      trigger="click"
    >
      {children}
    </Popover>
  );
};

export default PopoverSchoolManagement;
